export class State {
    stateid: number;
    statename: string;
    active: number;
}